import { topicsData } from '@/mocks/tanhua';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            探花爱好者最关注的话题标签，快速发现热门探花内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className={`group inline-flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 rounded-lg border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'border-primary-200 bg-primary-50 hover:bg-primary-100'
                  : 'border-background-200/70 bg-background-50 hover:border-accent-200'
              }`}
            >
              <span
                className={`text-sm md:text-base font-medium ${
                  topic.hot ? 'text-primary-700' : 'text-foreground-700'
                }`}
              >
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.count}讨论
              </span>
              {topic.hot && (
                <i className="ri-fire-line text-sm text-primary-500"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}